import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from "moment";



class DateTimeCellRender extends Component {
 
  render() {
    return this.props.value ? moment(this.props.value).format('MM/DD/YYYY HH:mm'):'';
  }
}

DateTimeCellRender.propTypes = {
  value: PropTypes.any,
};

export default DateTimeCellRender;